import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton({ to = "/", label = "Back to dashboard" }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(to)}
      data-testid="back-button"
      className="flex items-center gap-2 text-sm text-slate-400 hover:text-slate-200 mb-4"
    >
      <ArrowLeft className="w-4 h-4" /> {label}
    </button>
  );
}
